module.exports = __webpack_public_path__ + "static/ah_logo_30-da0e3d007990c1e9782c1ce8bf7e1cdc.png";